// NOTE: This code is used in vite.config.ts as well as App.tsx

async function loadModule(moduleName) {
  // Assign the module to a variable:
  // Can't use assert as it's experimental and needs some special settngs for babel
  //const module = await import(/* @vite-ignore */ moduleName, { assert: { type: "json" }});

  // MUST USE w/o assert for loc:vite to work
  // If using assert, it fails in browser due to type error.
  // Just the way it fails for makeRelease and for loc:node.
  const module = await import(/* @vite-ignore */ moduleName);

  //const module = await import(/* @vite-ignore */ moduleName, { assert: { type: "json" }});
  //const module = await import(/* @vite-ignore */ moduleName, { with: { type: "json" }});
  //const module = await import(`${moduleName}`, { assert: { type: "json", "resolution-mode": "import"  }});

  //return module.default;
  return module;
}


function stringToFunctionAndExecute(str) {
  let func = new Function(str);
  return (func()); // <--- note the parenteces
}

function stringToFunctionOnly(str) {
  let func = new Function(str);
  return func;
}

const logList = [
];

export { loadEnvVar };
async function loadEnvVar(dir) {
  //const { appCode, appEnv, appMode, appNodeEnv, appVersion, path } = options; 

  //console.log('dump process.env', process.env);                                           // see below
  //console.log('dump import.meta', import.meta);                                           // none

  let appCode, appEnv, appMode, appNodeEnv, appVersion;
  if ((typeof process !== 'undefined') && process && process.env) {
    // avail when using: node to build ssg
   appCode = process?.env?.VITE_APP_CODE;
   appEnv = process?.env?.VITE_MODE;
   appMode = process?.env?.VITE_MODE;
   appNodeEnv = process?.env?.VITE_NODE_ENV;
   appVersion = process?.env?.VITE_APP_VERSION;
  }
  else
    if (import.meta && import.meta.env) {
      // avail in browser when using: npm run loc:vite and npm run dev:build:all:release
      appCode = import.meta?.env.VITE_APP_CODE;
      appEnv = import.meta?.env.VITE_MODE;
      appMode = import.meta?.env.VITE_MODE;
      appNodeEnv = import.meta?.env.VITE_NODE_ENV;
      appVersion = import.meta?.env.VITE_APP_VERSION;
    }
  else {
    console.error('loadEnvVar: Unable to access basic env. var. for loading env. var. file');
    return null;
  }

  //const path = `/src/data/${appCode}_${appEnv}.js`;
  const path = dir + `${appCode}_${appEnv}.js`

  //console.log(`entry-client:loadEnv appCode: ${appCode}, appEnv: ${appEnv}, auth url: ${envVar.AUTH_APP_URL}`)

  const module = await loadModule(path);

  const packageJsonVar = {
    // Following are supplied via package.json
    MODE : appMode,                 // 
    NODE_ENV : appNodeEnv,          //
    APP_VERSION : appVersion,       // takes care of GITVERSION

    //RECALLS_SSG_LIMIT : import.meta.env.VITE_RECALLS_SSG_LIMIT,   // <<<< Is this req'd on client side???
    // Following may not be accessible from client side!!! As it does not start with VITE_xxxx
    // And are not needed on client side. They are either temporary or only for SSG generation
    //GITBRANCH : process.env.GITBRANCH,
    //GITHASH : process.env.GITHASH,
    //GITVERSION : process.env.GITVERSION,
    //SSG : process.env.SSG,
    //SSGTYPE : process.env.SSGTYPE,
  };

  const envVar = { ...module.envVar, ...packageJsonVar};

  if (appEnv === 'loc' || appEnv === 'dev') {
    envVar['logList'] = logList;
  }

  return envVar;
}	 
